<template>
  <v-btn
    :color="color"
    @click="$emit('click', $event)"
    v-bind="attrs"
    v-on="listeners"
  >
    <slot />
  </v-btn>
</template>

<script>
export default {
  name: 'AppButtonCancel',
  inheritAttrs: false,
  computed: {
    color() {
      return this.$attrs.color || 'cancelButton'
    },
    attrs() {
      const { color, ...attrs } = this.$attrs
      return attrs
    },
    listeners() {
      const { click, ...listeners } = this.$listeners
      return listeners
    },
  },
}
</script>
